import React, { useContext, useState } from 'react';
import axios from 'axios'
import styles from './big-car-confirmation.module.scss'
import { StateContext, DispatchContext } from 'src/AppContext'
import { IOrder, IState } from 'src/Interface'
import Button from 'src/components/button/Button';
import { isBefore } from 'date-fns';
import { baseApiURL } from 'src/utils/utils'
import { toast } from 'react-toastify';
import { gaEvenActions, gaEvent, gaEventCategories } from 'src/utils/ga/ga';
import { gaOrderedTripMapper, gaOrderTypes, gaUserMapper } from 'src/utils/ga/gaMapper';

interface Props {
  close: () => null
  order: IOrder
}

const BigCarConfirmation: React.FunctionComponent<Props> = ({ close, order }: Props) => {
  const state: IState = useContext(StateContext)
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const [loading, setLoading] = useState(false)


  const createOrder = () => {
    setLoading(true)
    axios(`${baseApiURL()}/current_date`, {
      headers: {
        Authorization:
          `Bearer ${state.user.accessToken}`
      }
    })
      .then((result) => {
        return result.data
      }).then((date) => {
        return axios.post(`${baseApiURL()}/orders`, {
          bookingModuleUpdatedAt: order.bookingModuleUpdatedAt,
          tripType: order.id ? 'FIXED' : 'METERED',
          requestedPickup: isBefore(new Date(order.requestedPickup), new Date(date)) ? new Date(date).toISOString() : order.requestedPickup,
          numberOfPeople: order.numberOfPeople,
          pickupAddress: order.pickupAddress,
          fixedTripId: order.fixedTripId,
          destinationAddress: order.destinationAddress,
          reference: order.reference ? order.reference : null,
          project: order.project ? order.project : null,
          numberOfCars: order.numberOfCars ? order.numberOfCars : 1,
          comment: order.comment ? order.comment : null,
          customerName: order.customerName ? order.customerName : null,
          customerPhone: order.phone ? order.phone : null,
          accountId: order.accountId,
          attributeIds: order.attributes
        }, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        })
      }).then((result) => {
        setLoading(false)
        toast(
          <div className='tw-flex tw-items-center'>
            <svg className={styles.spinner} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <div>
              <h3>Anmod om storvogn</h3>
              <span>Vær opmærksom på at bestilling af Storvogn kan tage et par minutter før vi kan bekræfte. Vi sender en notifikation når vi har fundet en vogn til jer.</span>
            </div>
          </div>
          , { autoClose: 10000 })
        dispatch({ type: 'SET_USER_ORDERS', userOrders: ([...result.data, ...state.userOrders]) })
        gaEvent(gaEventCategories.orders, gaEvenActions.ordered_trip, gaUserMapper(state), gaOrderedTripMapper(gaOrderTypes.big_car_order, order, result.data[0]))
        close()
      }).catch((err) => {
        toast(err.response.data.message)
      })
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>Important!</p>
        <p className={`${styles.text} tw-mb-3`}>Vores storvogne er meget efterspurgte, hvorfor vi skal checke de enkelte føreres kalendere før bestilling. </p>
        <p className={`${styles.text} tw-mb-3`}>Det kan derfor tage op til 120 sekunder, før vi kan give dig et svar.</p>
        <p className={`${styles.text} tw-mb-3`}>Vi giver dig  besked, så snart vi har fundet en vogn til dig.</p>
      </div>
      <footer className={styles.footer}>
        <Button handleClick={close} modifiers='tw-mr-auto' type='destructive' label='Annuller' />
        <Button loading={loading} handleClick={createOrder} type='primary' label='Bestil' />
      </footer>
    </div>
  )
}

export default BigCarConfirmation